<template>
    <report-layout
        :report="report"
        :show-header="false"
        :show-navigation-menu="false"
        current-step="mortgage_estimate"
    >
        <div class="bg-white rounded-lg shadow-md p-6">
            <div class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                <div>
                    <h2 class="text-2xl font-bold text-gray-900">Your report is ready</h2>
                    <p class="mt-1 text-sm text-gray-600">Before you look at your score, see what you could qualify for with a free loan estimate.</p>
                </div>
                <inertia-link
                    :href="route('reports.credit-report', report.id)"
                    class="shrink-0 whiteButton"
                    data-test="skip"
                >
                    Skip, show my score
                </inertia-link>
            </div>

            <div class="mt-6">
                <mortgage-research-widget />
            </div>
        </div>
    </report-layout>
</template>

<script>
import ReportLayout from './ReportLayout.vue'
import MortgageResearchWidget from '@/Components/MortgageResearchWidget.vue'

/**
 * 86bc8uyd2: shown once, right after a renter buying a home first pulls
 * their report, and from "Estimate My Loan" on the self credit check list.
 * Not a step on the rail — Rich asked for a page after the steps, not a
 * fifth step.
 */
export default {
    components: {
        ReportLayout,
        MortgageResearchWidget,
    },
    props: {
        report: {
            type: Object,
            required: true,
        },
    },
}
</script>
